// 抹平 ios 和 android 的差异，统一处理

import React, { useEffect, useRef, useState } from 'react';
import clsx from 'classnames';
import { getTrans } from '@/utils/tools';
import { isIosReg } from '@/utils/constants';
import initStore from '@/stores/init';


type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const GeneralTextArea: React.FC<Props> = (props) => {
  const [value, setValue] = useState((props.value ?? '').toString());
  const [maxLength, setMaxLength] = useState(props.maxLength);

  const inputRef = useRef<HTMLTextAreaElement>(null);
  const adjustCursorPosition = (e: any) => {
    console.log('textarea scroll');
    const event = e || window.event;
    event.target.setSelectionRange(event.target.textLength - 1, event.target.textLength - 1);
    setTimeout(function() {
      event.target.setSelectionRange(event.target.textLength, event.target.textLength);
    }, 0);
  };

  useEffect(() => {
    inputRef.current!.addEventListener('scroll', adjustCursorPosition);
    return () => {
      inputRef.current!.removeEventListener('scroll', adjustCursorPosition);
    };
  }, []);

  const handleTextAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;

    setValue(value);
    setMaxLength(handleCurrentMaxLength(value));

    props.onChange?.(event);
  };

  const handleCurrentMaxLength = (value: string) => {
    if (!props.maxLength) {
      return;
    }

    const { userAgent } = window.navigator;
    const isIos = isIosReg.test(userAgent);

    if (isIos) {
      const reg = new RegExp(/\n/g);
      const lineNum = value.match(reg);
      return lineNum ? lineNum.length + props.maxLength : props.maxLength;
    } else {
      return props.maxLength;
    }
  };

  const handleInputFocus = () => {
    console.log('input focus');
    initStore.UPDATE_BOTTOMBAR_HIDDEN(true);
  };

  const handleInputBlur = () => {
    console.log('input blur');
    setTimeout(() => {
      initStore.UPDATE_BOTTOMBAR_HIDDEN(false);
    }, 100); // 延迟恢复bottom bar，给点击submit按钮留下足够时间触发
  };


  return <div className="freetext-wrap">
    <div className="freetext-label-wrap">
      <span className="freetext-label-text">{getTrans('feedback_option_freetext_placeholder')}</span>
      <span className="freetext-length">
        {value.length}
        <span className="freetext-label-text">/{props.maxLength}</span>
      </span>
    </div>
    <textarea
      ref={inputRef}
      disabled={props.disabled}
      className={clsx('freetext-textarea', { disabled: props.disabled })}
      value={value}
      onChange={handleTextAreaChange}
      onFocus={handleInputFocus}
      onBlur={handleInputBlur}
      maxLength={maxLength}
    />
  </div>;
};

export default GeneralTextArea;
